import React from 'react';
import styled from '@emotion/styled';

// An on/off switch with a 44px hit area (touch targets on tablets).
const Hit = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
`;

const Track = styled.button`
  width: 40px;
  height: 22px;
  border-radius: 11px;
  border: none;
  cursor: pointer;
  position: relative;
  transition: background 0.2s;
  background: ${p => (p.$on ? '#2563eb' : 'rgba(255,255,255,0.15)')};
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${p => (p.$on ? '21px' : '2px')};
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
    transition: left 0.2s;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export default function Toggle({ on, onChange, disabled = false, label }) {
  return (
    <Hit>
      <Track
        type="button"
        role="switch"
        aria-checked={on}
        aria-label={label}
        $on={on}
        disabled={disabled}
        onClick={() => onChange(!on)}
      />
    </Hit>
  );
}
